export const OPEN_DROPDOWN_TRIGGER_KEYPRESS = [
  'Enter',
  'Space',
  'ArrowDown',
  'ArrowUp',
];
